export default {
    section: 'Buyer Information',
    name: 'deal-support-buyer-information',
    items: [
        {
            type: 'inline',
            text: 'Contact Information',
            items: [
                {
                    type: 'text-field',
                    name: 'buyer-full-name',
                    width: 0,
                    props: {
                        hidden: true,
                        formula: {
                            name: 'join',
                            arguments: {
                                targets: [
                                    'buyer-first-name',
                                    'buyer-last-name'
                                ]
                            }
                        }
                    }
                },
                {
                    type: 'text-field',
                    name: 'buyer-first-name',
                    width: 3,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'buyer-last-name',
                    width: 3,
                    props: {
                        label: 'Last Name'
                    }
                }
            ],
            subItems: [
                {
                    type: 'text-field',
                    text: ' ',
                    name: 'buyer-address',
                    props: {
                        label: 'Notice Address'
                    }
                },
                {
                    type: 'inline',
                    text: ' ',
                    items: [
                        {
                            type: 'text-field',
                            name: 'buyer-city',
                            width: 3,
                            props: {
                                label: 'City'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'buyer-state',
                            width: 1,
                            props: {
                                label: 'State',
                                items: [
                                    // TODO: Add Swap States
                                    {
                                        text: 'swap-states',
                                        value: 'swap-states'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'buyer-zip',
                            width: 2,
                            props: {
                                label: 'Zip'
                            }
                        }
                    ]
                },
                {
                    type: 'inline',
                    text: ' ',
                    items: [
                        {
                            type: 'text-field',
                            text: 'Email Address',
                            name: 'buyer-email',
                            width: 3,
                            props: {
                                label: 'Email Address'
                            }
                        },
                        {
                            type: 'text-field',
                            text: 'Phone Number',
                            name: 'buyer-phone',
                            width: 3,
                            props: {
                                label: 'Phone Number'
                            }
                        },
                    ]
                }
            ]
        },
        {
            type: 'text-field',
            text: 'BD/Custodian',
            name: 'buyer-bd-custodian',
            props: {
                label: 'BD/Custodian'
            }
        },
        {
            type: 'text-field',
            text: 'Formal Company Name',
            name: 'buyer-company-name',
            props: {
                label: 'Company Name'
            },
            subItems: [
                {
                    type: 'text-field',
                    text: 'DBA (if applicable)',
                    name: 'buyer-company-dba',
                    props: {
                        label: 'DBA'
                    }
                }
            ]
        },
        {
            text: 'Entity Type',
            type: 'selectlist',
            name: 'buyer-entity-type',
            width: 3,
            props: {
                label: 'Entity Type',
                // TODO: Add Swap Entity Types
                items: [
                    {
                        text: 'swap-entity-types',
                        value: 'swap-entity-types'
                    }
                ]
            }
        },
        {
            type: 'text-field',
            text: 'Principal Place of Business',
            name: 'buyer-principle-address-street',
            props: {
                label: 'Address'
            },
            subItems: [
                {
                    type: 'inline',
                    text: ' ',
                    items: [
                        {
                            type: 'text-field',
                            name: 'buyer-principle-address-city',
                            width: 3,
                            props: {
                                label: 'City'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'buyer-principle-address-state',
                            width: 1,
                            props: {
                                label: 'State',
                                items: [
                                    // TODO: Swap States
                                    {
                                        text: 'swap-states',
                                        value: 'swap-states'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'buyer-principle-address-zip',
                            width: 2,
                            props: {
                                label: 'Zip'
                            }
                        }
                    ]
                }
            ]
        },
        {
            type: 'selectlist',
            text: 'State of Formation {if applicable)',
            name: 'buyer-state-formation',
            props: {
                label: 'State of Formation',
                items: [
                    // TODO: Add swap states data
                    {
                        text: 'swap-states',
                        value: 'swap-state'
                    }
                ]
            }
        },
        {
            text: 'Owners',
            type: 'data-table',
            name: 'buyer-owner-information',
            props: {
                headers: [
                    {
                        text: 'Name',
                        value: 'full-name'
                    },
                    {
                        text: 'Ownership Percentage',
                        value: 'ownership-percentage',
                        format: 'percent'
                    }
                ],
                newItemLabel: 'Add An Owner',
                noDataLabel: 'Please Add An Owner'
            }
        },
        {
            type: 'radio-list',
            text: 'Practice Type',
            name: 'buyer-practice-type',
            props: {
                items: [
                    // TODO: Add Practice Type Swap logic
                    // "Registered Representative" is included in the swap practice type list so it can be removed
                    // It is only included for testing the dependency question below
                    {
                        text: 'Registered Representative',
                        value: 'registered-representative'
                    },
                    {
                        text: 'swap-practice-type',
                        value: 'swap-practice-type'
                    }
                ]
            },
            subItems: [
                {
                    type: 'selectlist',
                    text: 'Will the buyer move to seller\'s broker-dealer to buy business',
                    name: 'buyer-change-bd',
                    props: {
                        items: [
                           {
                               text: 'Yes',
                               value: 'yes'
                           },
                           {
                               text: 'No',
                               value: 'no'
                           }
                        ]
                    },
                    dependencies: {
                        items: [
                            // TODO: Ensure that this still shows for "Registered Representative" when practice types are swapped in
                            {
                                name: 'buyer-practice-type',
                                value: 'registered-representative'
                            }
                        ]
                    }
                }
            ]
        },
        {
            type: 'selectlist',
            text: 'Please provide the states where your clients are located',
            name: 'buyer-client-states',
            width: 3,
            props: {
                multiple: true,
                items: [
                    // TODO: Enter swap states logic
                    {
                        text: 'swap-states',
                        value: 'swap-states'
                    },
                    {
                        text: 'more-swap-states',
                        value: 'more-swap-states'
                    }
                ]
            }
        },
        {
            type: 'checkbox-list',
            text: 'Purchasing as:',
            name: 'buyer-purchasing-as',
            props: {
                items: [
                    {
                        text: 'Individual',
                        value: 'individual'
                    },
                    {
                        text: 'Company',
                        value: 'company'
                    }
                ]
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/deal-support/valuation-data/buyer.js